import { SocraticSessionEntry } from "@/features/socratic/components/socratic-session-entry";
import { AssessmentSettingsFragment } from "@/generated/graphql";
import { useAppParams } from "@/ui/app/use-app-params";

interface Props {
  /** Current Answer Block ID */
  answerBlockId: string;
  /** Prevents new recordings when true. */
  isReadonly?: boolean;
  /** Maximum number of recording attempts allowed. `null` means unlimited. */
  maxAttempts: number | null;
  /** Required video response length in seconds. */
  responseTimeSeconds: number | null;
  /** Preparation time before recording starts, in seconds. */
  preparationTimeSeconds: number | null;
  /** Assessment Settings related to Viva */
  vivaAssessmentSettings: Pick<
    AssessmentSettingsFragment,
    "vivaReattemptWindowTime" | "vivaCameraRequiredDisabled"
  >;
}

/**
 * Answer form for video response questions.
 *
 * Currently Video question types support only a Socratic Interaction(dialogue)
 * which includes the video recording functionality.
 */
export function VideoResponseForm(props: Props) {
  const { workId } = useAppParams();
  const {
    answerBlockId,
    isReadonly,
    maxAttempts,
    responseTimeSeconds,
    preparationTimeSeconds,
    vivaAssessmentSettings: { vivaReattemptWindowTime },
  } = props;

  return (
    <div
      style={{
        padding: "0 45px",
        marginBottom: 32,
        width: "100%",
        maxWidth: 800,
      }}
    >
      <SocraticSessionEntry
        answerBlockId={answerBlockId}
        workId={workId}
        isReadonly={isReadonly}
        responseRequirements={{
          responseTimeSeconds,
          preparationTimeSeconds,
          baseMaxAttempts: maxAttempts,
          vivaReattemptWindowTime,
        }}
      />
    </div>
  );
}
